import { Col, Container, Row, Stack } from "react-bootstrap"

const HireNodejsDeveloperContent = () => {  
    return (
                
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>Hire Node.js Developers for Fast, Scalable & Real-Time Applications</h2>
                        <p>
                            Looking to build high-performance web apps, real-time APIs, or scalable backend systems? Our expert Node.js developers bring deep expertise in JavaScript, event-driven architecture, and modern frameworks to help you build fast, reliable, and scalable server-side solutions.
                        </p>
                    </Stack>

                    <Stack className="hire-content-info">
                        <h2>Why Hire Node.js Developers from Us?</h2>
                        <ul>
                            <li>
                                <b>Proven Node.js Expertise</b>
                                <p>
                                    Our developers specialize in building fast and efficient backends using Node.js, Express.js, and related technologies.
                                </p>
                            </li>
                            <li>
                                <b>Real-Time Application Development</b>
                                <p>
                                    Build chat apps, live-streaming platforms, or collaborative tools with real-time capabilities using WebSockets and Socket.IO.
                                </p>
                            </li>
                            <li>
                                <b>Microservices & RESTful APIs</b>
                                <p>
                                    We architect scalable systems using microservices and well-structured REST APIs for better maintainability and performance.
                                </p>
                            </li>
                            <li>
                                <b>Database Integration</b>
                                <p>
                                    Seamless integration with MySQL, MongoDB, and PostgreSQL — optimized for speed and reliability.
                                </p>
                            </li>
                            <li>
                                <b>DevOps & Deployment</b>
                                <p>
                                    We assist with CI/CD pipelines, Docker, and cloud deployment (AWS, GCP, Azure) for smooth delivery and scalability.
                                </p>
                            </li>
                        </ul>
                    </Stack>

                    <Stack className="hire-content-info">
                        <h2>Our Node.js Development Services</h2>
                        <ul>
                            <li>Custom Backend Development</li>
                            <li>RESTful & GraphQL API Development</li>
                            <li>Real-Time Chat & Collaboration Tools</li>
                            <li>Microservices Architecture</li>
                            <li>Node.js with React/Vue Frontends</li>
                            <li>Server-Side Rendering & API Performance Optimization</li>
                        </ul>
                    </Stack>

                    <Stack className="hire-content-info">
                        <h2>Start Building with Node.js Today</h2>
                        <p>
                            Supercharge your backend with our expert Node.js developers. From MVPs to enterprise applications — we help you go live faster with powerful, scalable solutions. Contact us for a tailored hiring plan and cost estimate.
                        </p>
                    </Stack>

                </Col>
            </Row>
        </Container>
    )
}

export default HireNodejsDeveloperContent;